
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta } from "/app/pages/faq.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as verifyl1suJ3zT7AL2RaLcTuuojB_8UsVA3kw9L_gPZi3lvLwMeta } from "/app/pages/verify.vue?macro=true";
import { default as contactufjgRVR80M94tPXoOoARnsatRQ8kqFsigR6NqG_45FbxIMeta } from "/app/pages/contact.vue?macro=true";
import { default as registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta } from "/app/pages/register.vue?macro=true";
import { default as complaintx3uWkYrJBPJWg1p2bfl_45bnv3t3d0A4wnHOWkPxWjHBMMeta } from "/app/pages/complaint.vue?macro=true";
import { default as promocionId_45l0Yp9WM1vdmwcJVAzD_45_45X4YBoRAfBb9ykInSC_45CoMeta } from "/app/pages/promocion.vue?macro=true";
import { default as email_45sentM6Hwfqkt3pvv66m_PcLVz3dV4tGCFMeHBgtK2g0L1XoMeta } from "/app/pages/email-sent.vue?macro=true";
import { default as family_cardXndL2Zi8h_45zKTH0Tiqve1uqOehpCuxdusyLAavmiJFwMeta } from "/app/pages/family_card.vue?macro=true";
import { default as regulationshtxxKm_45fc0swzsEiVODsapeERPSy_453VtTMr4h3YGbS8Meta } from "/app/pages/regulations.vue?macro=true";
import { default as verify_45emailcrfHPrU4LwRvDPJwzEjjSYduPRZ3Xqz6TNa8vrqloPMMeta } from "/app/pages/verify-email.vue?macro=true";
import { default as indexF1_dP0HECEkwEGBm1Z_45T81DlZYXsU7etJSP2_45qEb5OEMeta } from "/app/pages/catalog/index.vue?macro=true";
import { default as indexPYMehh1H3I51I_Jt_45B2w91jhAIWvwCrr7OI55V5sjLcMeta } from "/app/pages/profile/index.vue?macro=true";
import { default as request_45loginCZ3azQNPc1yN0LJSaMHkxILP91Eif5EZHrQ6Tlj7KTgMeta } from "/app/pages/request-login.vue?macro=true";
import { default as badgesPpR8WrSUB1T9sevAtthT_8NMk8bryGUB6uJHQMvPiWUMeta } from "/app/pages/profile/badges.vue?macro=true";
import { default as updateNhCdDqfB6Rusg_Vle97jVyR9p7_452lR0XiCGPYC45tNgMeta } from "/app/pages/profile/update.vue?macro=true";
import { default as successtZM_nTurBr_iraURtJocI0L41wjXOqTKq1DSk_45vnZaAMeta } from "/app/pages/catalog/success.vue?macro=true";
import { default as _91id_93r9KMB72zWTJ_IBhTXuStTVcV6EiJbmh_45UnxWYS_45Es1kMeta } from "/app/pages/profile/coupons/[id].vue?macro=true";
import { default as indexYtXZUc6WAG0nWirpRPX_45mmkn5KNOb9kIztNU4LWGXfIMeta } from "/app/pages/profile/coupons/index.vue?macro=true";
import { default as couponsPwp_NYvr_twbId4etPeyRAMUXxH4uRN3dfVqsgWpf6kMeta } from "/app/pages/profile/coupons.vue?macro=true";
import { default as registerACFEPdlHRsArVmbw9hLei0x1ZHIDGUjro5ILwo0sBJsMeta } from "/app/pages/catalog/register.vue?macro=true";
import { default as email_45sentY_45KEYJnrPcA3M6pVkyO239rIYBTfD_45E0rhMx6_d7yHUMeta } from "/app/pages/catalog/email-sent.vue?macro=true";
import { default as condiciones_45family_45cardavdBDjRh4kOZIlwOePbzVGo6BmEgwfbgjjCUNGRlk7kMeta } from "/app/pages/condiciones-family-card.vue?macro=true";
import { default as incidencias_45family_45clubVvOBORf9hS0kzbBl2zp9nPCub0jCx45Xb3wUS8al1yUMeta } from "/app/pages/incidencias-family-club.vue?macro=true";
import { default as condiciones_45promocionalestexshyzO_4AODpLXSdLZtyd190AwUL12GSHbIVmf0_45AMeta } from "/app/pages/condiciones-promocionales.vue?macro=true";
export default [
  {
    name: "faq___es",
    path: "/faq",
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___pt",
    path: "/faq",
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "index___es",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "verify___es",
    path: "/verify",
    meta: { ...(verifyl1suJ3zT7AL2RaLcTuuojB_8UsVA3kw9L_gPZi3lvLwMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/app/pages/verify.vue")
  },
  {
    name: "verify___pt",
    path: "/verify",
    meta: { ...(verifyl1suJ3zT7AL2RaLcTuuojB_8UsVA3kw9L_gPZi3lvLwMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/app/pages/verify.vue")
  },
  {
    name: "contact___es",
    path: "/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "contact___pt",
    path: "/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "register___es",
    path: "/hazte-socio",
    meta: { ...(registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "register___pt",
    path: "/torna-te-membro",
    meta: { ...(registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "complaint___es",
    path: "/complaint",
    component: () => import("/app/pages/complaint.vue")
  },
  {
    name: "complaint___pt",
    path: "/complaint",
    component: () => import("/app/pages/complaint.vue")
  },
  {
    name: "promocion___es",
    path: "/legal/condiciones-promocionales",
    component: () => import("/app/pages/promocion.vue")
  },
  {
    name: "promocion___pt",
    path: "/legal/condicoes-promocionais",
    component: () => import("/app/pages/promocion.vue")
  },
  {
    name: "email-sent___es",
    path: "/email-sent",
    meta: {"middleware":"guest"},
    component: () => import("/app/pages/email-sent.vue")
  },
  {
    name: "email-sent___pt",
    path: "/email-sent",
    meta: {"middleware":"guest"},
    component: () => import("/app/pages/email-sent.vue")
  },
  {
    name: "family_card___es",
    path: "/legal/reglamento-family-card",
    component: () => import("/app/pages/family_card.vue")
  },
  {
    name: "family_card___pt",
    path: "/legal/regulamento-family-card",
    component: () => import("/app/pages/family_card.vue")
  },
  {
    name: "regulations___es",
    path: "/politica-de-privacidad",
    component: () => import("/app/pages/regulations.vue")
  },
  {
    name: "regulations___pt",
    path: "/politica-de-privacidade",
    component: () => import("/app/pages/regulations.vue")
  },
  {
    name: "verify-email___es",
    path: "/verify-email",
    meta: {"middleware":"guest"},
    component: () => import("/app/pages/verify-email.vue")
  },
  {
    name: "verify-email___pt",
    path: "/verify-email",
    meta: {"middleware":"guest"},
    component: () => import("/app/pages/verify-email.vue")
  },
  {
    name: "catalog-index___es",
    path: "/folleto-de-navidad",
    meta: { ...(indexF1_dP0HECEkwEGBm1Z_45T81DlZYXsU7etJSP2_45qEb5OEMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/app/pages/catalog/index.vue")
  },
  {
    name: "catalog-index___pt",
    path: "/folheto-de-natal",
    meta: { ...(indexF1_dP0HECEkwEGBm1Z_45T81DlZYXsU7etJSP2_45qEb5OEMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/app/pages/catalog/index.vue")
  },
  {
    name: "profile___es",
    path: "/profile",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/profile/index.vue")
  },
  {
    name: "profile___pt",
    path: "/profile",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/profile/index.vue")
  },
  {
    name: "request-login___es",
    path: "/request-login",
    meta: { ...(request_45loginCZ3azQNPc1yN0LJSaMHkxILP91Eif5EZHrQ6Tlj7KTgMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/app/pages/request-login.vue")
  },
  {
    name: "request-login___pt",
    path: "/request-login",
    meta: { ...(request_45loginCZ3azQNPc1yN0LJSaMHkxILP91Eif5EZHrQ6Tlj7KTgMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/app/pages/request-login.vue")
  },
  {
    name: "profile-badges___es",
    path: "/profile/badges",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/profile/badges.vue")
  },
  {
    name: "profile-badges___pt",
    path: "/profile/badges",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/profile/badges.vue")
  },
  {
    name: "profile-update___es",
    path: "/profile/update",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/profile/update.vue")
  },
  {
    name: "profile-update___pt",
    path: "/profile/update",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/profile/update.vue")
  },
  {
    name: "catalog-success___es",
    path: "/folleto-de-navidad/gracias",
    meta: successtZM_nTurBr_iraURtJocI0L41wjXOqTKq1DSk_45vnZaAMeta || {},
    component: () => import("/app/pages/catalog/success.vue")
  },
  {
    name: "catalog-success___pt",
    path: "/folheto-de-natal/obrigado",
    meta: successtZM_nTurBr_iraURtJocI0L41wjXOqTKq1DSk_45vnZaAMeta || {},
    component: () => import("/app/pages/catalog/success.vue")
  },
  {
    name: couponsPwp_NYvr_twbId4etPeyRAMUXxH4uRN3dfVqsgWpf6kMeta?.name,
    path: "/profile/coupons",
    component: () => import("/app/pages/profile/coupons.vue"),
    children: [
  {
    name: "profile-coupons-id___es",
    path: ":id()",
    component: () => import("/app/pages/profile/coupons/[id].vue")
  },
  {
    name: "profile-coupons___es",
    path: "",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/profile/coupons/index.vue")
  }
]
  },
  {
    name: couponsPwp_NYvr_twbId4etPeyRAMUXxH4uRN3dfVqsgWpf6kMeta?.name,
    path: "/profile/coupons",
    component: () => import("/app/pages/profile/coupons.vue"),
    children: [
  {
    name: "profile-coupons-id___pt",
    path: ":id()",
    component: () => import("/app/pages/profile/coupons/[id].vue")
  },
  {
    name: "profile-coupons___pt",
    path: "",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/profile/coupons/index.vue")
  }
]
  },
  {
    name: "catalog-register___es",
    path: "/folleto-de-navidad/hazte-socio",
    meta: { ...(registerACFEPdlHRsArVmbw9hLei0x1ZHIDGUjro5ILwo0sBJsMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/app/pages/catalog/register.vue")
  },
  {
    name: "catalog-register___pt",
    path: "/folheto-de-natal/torna-te-membro",
    meta: { ...(registerACFEPdlHRsArVmbw9hLei0x1ZHIDGUjro5ILwo0sBJsMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/app/pages/catalog/register.vue")
  },
  {
    name: "catalog-email-sent___es",
    path: "/catalog/email-sent",
    meta: email_45sentY_45KEYJnrPcA3M6pVkyO239rIYBTfD_45E0rhMx6_d7yHUMeta || {},
    component: () => import("/app/pages/catalog/email-sent.vue")
  },
  {
    name: "catalog-email-sent___pt",
    path: "/catalog/email-sent",
    meta: email_45sentY_45KEYJnrPcA3M6pVkyO239rIYBTfD_45E0rhMx6_d7yHUMeta || {},
    component: () => import("/app/pages/catalog/email-sent.vue")
  },
  {
    name: "condiciones-family-card___es",
    path: "/condiciones-family-card",
    component: () => import("/app/pages/condiciones-family-card.vue")
  },
  {
    name: "condiciones-family-card___pt",
    path: "/condiciones-family-card",
    component: () => import("/app/pages/condiciones-family-card.vue")
  },
  {
    name: "incidencias-family-club___es",
    path: "/incidencias-family-club",
    component: () => import("/app/pages/incidencias-family-club.vue")
  },
  {
    name: "incidencias-family-club___pt",
    path: "/incidencias-family-club",
    component: () => import("/app/pages/incidencias-family-club.vue")
  },
  {
    name: "condiciones-promocionales___es",
    path: "/condiciones-promocionales",
    component: () => import("/app/pages/condiciones-promocionales.vue")
  },
  {
    name: "condiciones-promocionales___pt",
    path: "/condiciones-promocionales",
    component: () => import("/app/pages/condiciones-promocionales.vue")
  }
]